import { Component, EventEmitter, Input, Output, SimpleChanges, inject, OnChanges } from '@angular/core';
import { AddLoanComponent } from 'src/app/AddThings/add-loan/add-loan.component';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { BatchPaymentInterface } from 'src/model/batchPayment.interface';
import { Customer } from 'src/model/customer.model';
import { Loan } from 'src/model/loan.model';
import { Payment } from 'src/model/payment.model';
import { Profile } from 'src/model/profile.model';

@Component({
    selector: 'app-overlap-component',
    templateUrl: './overlap-component.component.html',
    styleUrls: ['./overlap-component.component.scss'],
    standalone: false
})
export class OverlapComponentComponent implements OnChanges {
  protected sharedService = inject(SharedService);

  @Input() payment: BatchPaymentInterface;
  @Input() availableSimpan = 0;
  @Input() selectedCustomer: Customer;
  @Input() selectedProfile: Profile;
  @Input() payWithSimpan = false;
  @Input() batchDate: Date;

  @Output() passOverlapDetails = new EventEmitter<any>();

  amount = 0;
  stamp = 0;
  serviceCharge = 0;
  payInterest = false;
  paymentDate: Date = new Date();

  addedLoanList: Loan[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.batchDate) {
      this.paymentDate = this.batchDate;
    }
  }

  deleteNewLoan(i: number) {
    this.addedLoanList.splice(i, 1);
  }

  openAddLoanDialog() {
    const modalRef = this.sharedService.openModal(AddLoanComponent, "largeModal");
    modalRef.componentInstance.selectedCustomer = this.selectedCustomer;
    modalRef.componentInstance.selectedProfile = this.selectedProfile;
    modalRef.componentInstance.isOverlap = true;
    modalRef.componentInstance.payWithSimpan = this.payWithSimpan;
    modalRef.componentInstance.batchDate = this.batchDate;

    modalRef.componentInstance.passEntry.subscribe((entry) => {
      this.addedLoanList.push(entry[0]);
    });
  }

  resetOverlap(payment: BatchPaymentInterface) {
    payment.isOverlap = false;
    payment.overlapAddedLoan = undefined;
    payment.paymentDetails = undefined;
    payment.totalPayment = 0;
    payment.panelOpenState = false;
  }

  getPaymentColor(totalPayment: number) {
    if (totalPayment == undefined || totalPayment == 0)
      return 'text-primary'
    else
      return 'text-success';
  }

  resetIntAndCharges() {
    this.stamp = 0;
    this.serviceCharge = 0;
    this.payInterest = false;
  }

  calculateTotalPayment() {
    return this.amount + this.stamp + this.serviceCharge + this.calculateIntAfterPart() - this.calculateTotalLoanOnHand() - this.calculateSimpanOut();
  }

  calculateIntAfterPart() {
    let int = 0;
    if (this.payInterest == true)
      int = (this.payment.loan.Balance - this.amount) * (this.payment.loan.InterestRate / 100)

    return int;
  }

  calculateTotalLoanOnHand() {
    let addedLoanOnHand = 0;
    if (this.addedLoanList != undefined && this.addedLoanList.length > 0)
      for (let i = 0; i < this.addedLoanList.length; i++) {
        addedLoanOnHand += this.sharedService.calculateTotalOnHand(this.addedLoanList[i]);
      }

    return addedLoanOnHand;
  }

  calculateSimpanOut() {
    let so = 0;
    if (this.payWithSimpan) {
      so += this.calculateIntAfterPart() + this.stamp + this.serviceCharge;

      for (let i = 0; i < this.addedLoanList.length; i++) {
        so += this.addedLoanList[i].Reserve;
      }
    }
    return so;
  }

  submit() {
    if (this.payment.loan.Balance - this.amount < 0)
      this.sharedService.openAlert("Overlap amount more than the loan amount!", ALERT_TYPE.DANGER);

    else if (this.addedLoanList.length == 0) {
      this.sharedService.openAlert("Please at least open 1 new loan", ALERT_TYPE.DANGER);
    }
    else {
      //INPROGRESS : CALCULATE INTEREST AFTER PRINCIPAL & RESERVE
      const reserve = 0;
      const interestAfterReducePrincipal = this.calculateIntAfterPart();

      this.payment.paymentDetails = new Payment(this.stamp, this.serviceCharge, 0, 0, this.paymentDate, "OVERLAP", [], reserve, 0, this.amount, 0, this.payInterest, interestAfterReducePrincipal);
      this.payment.overlapAddedLoan = this.addedLoanList;
      this.payment.panelOpenState = false;
      // var overlapObj = new Overlap(payment, this.addedLoanList);
      this.passOverlapDetails.emit(this.payment)
      this.sharedService.openAlert("Added OVERLAP payment into queue", ALERT_TYPE.SUCCESS);
    }
  }
}
